import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import App from './App';
import { startSiteUpdates } from './utils/siteUpdates';
import { handleTokenInvalidation } from './utils/tokenHandler';
import Message from './components/Message';

startSiteUpdates();

// 将Message组件挂载到全局window对象，使其在整个应用中可用
window.Message = Message;

// 配置axios默认设置来解决CORS问题
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.withCredentials = false;

// 添加全局响应拦截器处理token无效的情况
axios.interceptors.response.use(
  (response) => {
    // 检查响应中是否有code: -1，表示token无效
    if (response.data && response.data.code === -2) {
      handleTokenInvalidation(response.data.msg || '登录已失效，请重新登录');
    }
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 添加防抖函数
let playTimeout = null;
let lastPlayTime = 0;
const DEBOUNCE_TIME = 1000; // 1秒内不重复播放

// 通过创建新的Audio对象来播放
function playWithNewAudio() {
  try {
    const newAudio = new Audio(`${window.location.origin}/timer.mp3`);
    newAudio.volume = 1.0;
    newAudio.play()
      .then(() => console.log('备用音频播放成功'))
      .catch(err => console.error('备用音频播放也失败:', err));
  } catch (e) {
    console.error('创建备用音频对象失败:', e);
  }
}

// 添加一个全局函数来播放音频
window.playTimerSound = () => {
  // 检查是否已经有用户交互
  if (!document.body.classList.contains('user-interacted')) {
    console.log('用户尚未交互，不播放音效');
    return;
  }

  // 检查是否在防抖时间内
  const now = Date.now();
  if (now - lastPlayTime < DEBOUNCE_TIME) {
    console.log('音效播放太频繁，跳过');
    return;
  }
  lastPlayTime = now;

  // 清除之前的延时播放
  if (playTimeout) {
    clearTimeout(playTimeout);
    playTimeout = null;
  }

  try {
    console.log('全局函数尝试播放音效');

    // 尝试使用预定义的audio元素
    const audio = document.getElementById('timer-sound');
    if (audio) {
      audio.volume = 1.0;
      audio.currentTime = 0;

      const playPromise = audio.play();
      if (playPromise) {
        playPromise.then(() => {
          console.log('全局音效播放成功');
        }).catch(err => {
          console.error('全局音效播放失败:', err);
          // 只在播放失败时尝试备用方案
          playWithNewAudio();
        });
      }
    } else {
      playWithNewAudio();
    }
  } catch (error) {
    console.error('播放计时器音频出错:', error);
    playWithNewAudio();
  }
};

// 尝试预加载音频
const preloadTimerSound = () => {
  try {
    // 如果页面中已有音频元素，使用它
    let audio = document.getElementById('timer-sound');

    // 如果没有找到，创建并添加一个
    if (!audio) {
      audio = document.createElement('audio');
      audio.id = 'timer-sound';
      audio.src = `${window.location.origin}/timer.mp3`;
      audio.preload = 'auto';
      audio.style.display = 'none';
      document.body.appendChild(audio);
    }

    // 添加用户交互检测
    const markUserInteraction = () => {
      document.body.classList.add('user-interacted');
      // 移除事件监听器，因为我们只需要检测一次
      ['click', 'touchstart', 'keydown'].forEach(event => {
        document.removeEventListener(event, markUserInteraction);
      });
    };

    // 添加用户交互事件监听器
    ['click', 'touchstart', 'keydown'].forEach(event => {
      document.addEventListener(event, markUserInteraction);
    });

    console.log('预加载计时器音效');
    audio.load();
  } catch (e) {
    console.error('预加载音频失败:', e);
  }
};

// 页面加载完成后执行预加载
window.addEventListener('load', preloadTimerSound);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
